import { render, staticRenderFns } from "./service-unavailable.vue?vue&type=template&id=179964bf&"
import script from "./service-unavailable.vue?vue&type=script&lang=ts&"
export * from "./service-unavailable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports